import { IconTable, TableHead, TableHeadCell } from "@wg/wows-react-uikit";
import * as React from "react";
import headers from "./headers.settings";


export interface SearchResultTableHeadProps {
  stickyContainerId: string
}

class SearchResultTableHead extends React.PureComponent<SearchResultTableHeadProps> {

  onClick(e: any) {
    e.preventDefault();
  }

  render() {
    const {
      stickyContainerId
    } = this.props;

    const headersCell = headers.map((item: any, index: number) => {
      if (item.isHidden) return null;

      return (
        <TableHeadCell
          key={index}
          modify={item.modify}
          isSortable={false}
          isActive={false}
          // @ts-ignore
          onClick={this.onClick}
          tooltipText={item.tooltipText}
          tooltipParam={item.tooltipParam}
        >
          {item.glyph ? <IconTable glyph={item.glyph} /> : null}
          {item.text}
        </TableHeadCell>
      )
    })

    return (
      <TableHead stickyContainerId={stickyContainerId}>
        {headersCell}
      </TableHead>
    )
  }
}

export default SearchResultTableHead;